"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../../../type/entity");
function getCompletedCardContentIds(rootContentId, states) {
    const completedCardContentIds = [];
    const childStates = states.filter(state => state.rootContentId_contentId.indexOf(rootContentId) !== -1);
    for (const state of childStates) {
        if (state.completionStatus === entity_1.CompletionStatus.COMPLETE &&
            (state.contentType === entity_1.StateContentType.ASSIGNMENT_CARD ||
                state.contentType === entity_1.StateContentType.LEARNING_CARD ||
                state.contentType === entity_1.StateContentType.PEER_REVIEW_CARD) // doubt whether to include or not
        ) {
            completedCardContentIds.push(state.contentId);
        }
    }
    return completedCardContentIds;
}
exports.getCompletedCardContentIds = getCompletedCardContentIds;
//# sourceMappingURL=getCompletedCardContentIds.js.map